module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs--inner"
  }, _vm._l((_vm.tabs), function(tab) {
    return (tab.active !== false) ? _c('div', {
      key: tab.name,
      class: {
        'tab': true, 'is-active': _vm.activeTab == tab.name
      },
      on: {
        "click": function($event) {
          return _vm.setTab(tab.name)
        }
      }
    }, [_c('div', {
      staticClass: "tab--name"
    }, [_vm._v("\n        " + _vm._s(tab.title) + "\n      ")])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b2cedfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/Tabs.vue
// module id = 1810
// module chunks = 0